import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import config from './modules/config.js'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		user,
    config
	},

  //strict: true
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js